import {
  GeneralTableKeys,
  NumericTableKeys,
} from './components/util-component/SimpleTable/tableTypes'
import {
  InferenceAlgorithm,
  OptimizationAlgorithm,
} from './services/bayesianApi/models'

export const NETWORK_DIFF_URL_BASE = 'network-diff'
export const ASSUMPTION_SET_DIFF_URL_BASE = 'assumption-set-diff'
export const MAIN_NETWORK_NAME = '3.X development'
// KBE-848: where inference runs for a network with no explicit choice. LBP_IN_BROWSER
// keeps every ordinary inference off Modal -- the engine is a port of the same
// PGMax LBP, so the answer is the same one, without the round trip. Server-side
// callers (Marvin, the report, impact, the performance cron) have no browser and
// run the same engine locally there; see AGENTS.md gotcha 38.
export const DEFAULT_INFERENCE_ALGORITHM = InferenceAlgorithm.LBP_IN_BROWSER
// KBE-766: matches the bayesian-api Options default, so a job whose stored
// request has no options is not reported as having used the scipy optimizer.
export const DEFAULT_OPTIMIZATION_ALGORITHM =
  OptimizationAlgorithm.PGMAX_LBP_GRADIENT
export const LOTP_EQUATION = '∑ P(V | Ai)*P(Ai) = '
export const LOTP_INFO_TEXT = 'Expected value from law of total probability:'
export const MIN_TABLE_COLUMN_WIDTH_PX = 50
export const VERSION_CHECK_INTERVAL_MS = 60 * 1000 // 1 minute
export const RELATIVE_RISK_TOOLTIP_TEXT = 'Relative risk (RR)'
export const TABLE_LABELS = {
  VARIABLES: 'variables',
  VARIABLE_STATES: 'variable-states',
  ASSUMPTIONS: 'assumptions',
  ASSUMPTION_SETS: 'assumption-sets',
  REQUIREMENTS: 'requirements',
  ASSUMPTION_SETS_TABLE: 'assumption-sets-table',
}

export const PANEL_TITLES = {
  ASSUMPTION_SETS: 'Assumption Sets',
  VARIABLES: 'Variables',
}
export const TABLE_ROW_SELECTION_COLOR = 'blue.200'
export const STATIC_TABLE_COLUMN_WIDTHS: Partial<
  Record<GeneralTableKeys | NumericTableKeys, number>
> = {
  [GeneralTableKeys.SELECT]: 40,
  [GeneralTableKeys.CURRENT_STATUS]: 80,
}

export const TABLE_LABEL_SPECIFIC_DEFAULT_WIDTHS: Partial<
  Record<
    (typeof TABLE_LABELS)[keyof typeof TABLE_LABELS],
    Partial<Record<GeneralTableKeys | NumericTableKeys, number>>
  >
> = {
  [TABLE_LABELS.REQUIREMENTS]: {
    [GeneralTableKeys.VARIABLE_NAME]: 300,
    [NumericTableKeys.EXP]: 45,
    [NumericTableKeys.TOL]: 45,
    [NumericTableKeys.PRED]: 45,
    [NumericTableKeys.WERR]: 45,
    [NumericTableKeys.ERR]: 45,
    [NumericTableKeys.WCHG]: 55,
    [NumericTableKeys.PCHG]: 55,
  },
  [TABLE_LABELS.ASSUMPTION_SETS]: {
    // These two columns display value×100 (percentage scale) so the content-based
    // scanner, which measures the raw 0–1 value, underestimates their needed width.
    [NumericTableKeys.EXPECTATION_WITHOUT_ASSUMPTION]: 80,
    [NumericTableKeys.EXPECTATION_WITH_BASE_POPULATION]: 80,
  },
  [TABLE_LABELS.VARIABLE_STATES]: {
    [GeneralTableKeys.VARIABLE_NAME]: 300,
  },
}

// Disable virtualization in E2E tests (set NEXT_PUBLIC_DISABLE_VIRTUALIZATION=true in .env.test)
export const DISABLE_VIRTUALIZATION =
  process.env.NEXT_PUBLIC_DISABLE_VIRTUALIZATION === 'true'
